import React from 'react';
import PropTypes from "prop-types";
import { TextInput } from "components/common/TextInput.component";
import { Search } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";


const SearchGroupInput = (props) => {

    let handleChange = (e) => {
        if (e.target?.value?.trim().length !== 0 || props.value?.trim().length !== 0)
            return props.onInputChange(e)
    }

    return (
            <TextInput
                id="searchInput"
                type="text"
                className={props.className ? props.className : "col-md-12"}
                aria-label={props.ariaLabel}
                placeholder={props.placeholder ? props.placeholder : props.translate("myTasks.search")}
                value={props.value}
                onChange={handleChange}
                onClear={props.onClearInput}
                leftIcon={<Search size={ICON_SIZE.MEDIUM}/>}
                dataCy="myTasks.search"
                clearAriaLabel={props.translate("myTasks.clearSearch")}
            />
    );
}

export default SearchGroupInput;


SearchGroupInput.propTypes = {
    translate: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    ariaLabel: PropTypes.string,
    onInputChange: PropTypes.func,
    onClearInput: PropTypes.func,
    className: PropTypes.string
};